import React from 'react';
import { appOperations } from '../../App/store';
import { connect } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button } from '@mui/material';
import DialogCloseButton from '../buttons/DialogCloseButton';

const TextInformationDialog = (props) => {
    const { title,  text, buttonText, open, setProperty } = props;
    const onClose = () => setProperty('informationDialogOpen', false);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth='xs'
            fullWidth={true}
            aria-labelledby='confirmation-dialog-title'
        >
            <DialogTitle id='confirmation-dialog-title'>
                {title}
                <DialogCloseButton
                    onClick={onClose}
                />
            </DialogTitle>
            <DialogContent>
                <Typography>{text}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {buttonText ?? "OK"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(appOperations.setProperty(key, value));
    return { setProperty }
}

const mapStateToProps = (state) => {
    const {
        informationDialogOpen: open,
        informationDialogTitle: title,
        informationDialogText: text,
        informationDialogButtonText: buttonText
    } = state.app;

    return {
        open,
        title,
        text,
        buttonText
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextInformationDialog);